var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1649 2.02368V3.37285C14.1649 9.86733 10.5407 12.817 6.06994 12.817L4.78712 12.8169C4.92979 10.7849 5.56222 9.55527 7.21393 8.09419C8.02613 7.37569 7.95773 6.96089 7.55729 7.19915C4.80256 8.83805 3.4344 11.0538 3.37372 14.5913L3.3716 14.8408H2.02244C2.02244 13.9215 2.10049 13.0866 2.25568 12.3234C2.10018 11.4504 2.02244 10.2655 2.02244 8.76951C2.02244 5.04389 5.04265 2.02368 8.76824 2.02368C10.1174 2.02368 11.4666 2.69826 14.1649 2.02368Z",
    fill: "#19A947"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.19,
    height: 16.19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.826be811bbf0368536eab7b77c6e86f7.svg";
export { ForwardRef as ReactComponent };